import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: '30px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '20px 0',
      width: '100%'
    }
  },
  title: {
    margin: '0 0 19px',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    
    }
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'column',
      width: '100%',
    }
  },
  input: {
    display:'flex',
    paddingBottom: '24px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '12px',
      flexDirection: 'column',
      width: '100%',
    }
  }
}));

